import type { ChartSpec } from '../chartUtils';

export const CONFIG_KEYS = new Set([
  'x_key', 'y_key', 'label_key', 'value_key', 'lat_key', 'lng_key', 'name_key',
  'popup_keys', 'marker_color_key',
  'color', 'colors', 'color_by_key', 'x_label', 'y_label',
  'number_decimals', 'number_prefix', 'number_suffix',
  'show_values', 'show_legend', 'show_grid',
  'sort_data', 'stacked', 'group_key', 'min_value', 'max_value',
  'height', 'show_total', 'total_annotation', 'percentage',
]);

/**
 * Normalize a chart spec that may have config fields at the root level
 * (agent sometimes returns flat specs instead of nested config).
 */
export function normalizeSpec(raw: Record<string, unknown>): ChartSpec | null {
  if (!raw || !raw.chart_type || !raw.data || !Array.isArray(raw.data) || raw.data.length === 0) {
    return null;
  }

  // If config already exists and is an object, use as-is
  if (raw.config && typeof raw.config === 'object' && !Array.isArray(raw.config)) {
    return raw as unknown as ChartSpec;
  }

  // Extract config fields from root into a config object
  const config: Record<string, unknown> = {};
  const spec: Record<string, unknown> = {};

  for (const [k, v] of Object.entries(raw)) {
    if (CONFIG_KEYS.has(k)) {
      config[k] = v;
    } else {
      spec[k] = v;
    }
  }

  spec.config = config;
  return spec as unknown as ChartSpec;
}

/** Generate a safe filename from the chart title. */
export function safeFilename(title: string): string {
  return title.replace(/[^a-zA-Z0-9]+/g, '_').replace(/^_|_$/g, '').toLowerCase() || 'chart';
}
